import { AfterViewInit, Component, computed, OnInit } from '@angular/core';

import { JwtAuthService } from './shared/services/auth/jwt-auth.service';
import { AmplitudeService } from './shared/services/amplitude.service';
import { PersonMessagesEntityService } from './state/entity-services/person-messages-entity.service';
import { environment } from '../environments/environment';
import { filter } from 'rxjs/operators';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { WebCryptoSupportService } from './shared/services/webcrypto-support.service';
import { ClickTrackerService } from './shared/services/click-tracker.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { BackLinkService } from './shared/services/back-link.service';
import { ScrollRestorationService } from './shared/services/scroll-restoration.service';
import { AmplitudeExperimentsService } from './shared/services/amplitude.experiments.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'patient';
  growUpImage = false;
  showApp: boolean = environment.disableAnimationIntro;
  private currentUrl: string = this.router.url;


  private currentNavigation = computed(() => this.router.currentNavigation());

  constructor(
    private amplitudeExperimentsService: AmplitudeExperimentsService,
    private scrollRestorationService: ScrollRestorationService,
    private backLinkService: BackLinkService,
    private http: HttpClient,
    private clickTrackerService: ClickTrackerService,
    private webCryptoSupportService: WebCryptoSupportService,
    private router: Router,
    private personMessagesEntityService: PersonMessagesEntityService,
    private amplitudeService: AmplitudeService,
    private jwtAuthService: JwtAuthService) {

    this.growUpImage = false;
    this.router.events
      .pipe(filter(e => e instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.scrollRestorationService.save(this.currentUrl, this.scrollRestorationService.getContent()?.scrollTop);
      });

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {

        const nav = this.currentNavigation();
        const isBackOrForward = nav?.trigger === 'popstate';


        const url = event.urlAfterRedirects;

        if (isBackOrForward) {
          this.scrollRestorationService.markForRestore(url);
        } else {
          setTimeout(() => {
            this.scrollRestorationService.getContent()?.scrollTo(0, 0);
          });
        }
        this.currentUrl = url;
      });

    if (jwtAuthService.isLoggedIn) {
      this.personMessagesEntityService.checkJobEvents().subscribe({
        next: data => {
          console.info(data);
        }
      });
    }

    this.clickTrackerService.clicks$
      .pipe(takeUntilDestroyed())
      .subscribe((data) => {
        this.amplitudeService.sendEvent('element_clicked', {
          ...data,
          locale: jwtAuthService.locale
        });
      });

  }

  ngOnInit() {
    try {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault(); // Block auto banner install
        // (window as any).deferredPrompt = e;
      });
    } catch (e) {
      console.error(e);
    }
  }


  ngAfterViewInit() {

    this.amplitudeService.init(this.jwtAuthService.getUser());
    this.amplitudeService.setIdentify(this.jwtAuthService.getUser());
    this.jwtAuthService.setUserSentry();
    if (!!this.jwtAuthService.getUser()) {
      this.amplitudeExperimentsService.init();
    }


    if (this.showApp) { // ANIMATION DISABLED
      document.getElementById('APP_LOADER').remove();
      return;
    }

    setTimeout(() => {
      this.growUpImage = true;

      setTimeout(() => {
        document.getElementById('APP_LOADER').remove();
      }, 300);

      setTimeout(() => {
        this.showApp = true;
      }, 900);

    }, 3000);

  }


  runtimeError(): void {
    // Deve ir pro Sentry SEMPRE
    throw new Error('Timeout (b)');
  }

  http404(): void {
    // Alvo: status > 300 deve ir pro Sentry
    this.http.get('/api/nao-existe-404').subscribe({
      error: (err) => {
        // Força o erro a virar exceção dentro da Zone do Angular
        throw err;
      },
    });
  }

  httpStatus0(): void {
    // Status 0 é difícil de simular "limpo", mas uma forma é usar uma URL inválida
    this.http.get('https://dominio-que-nao-existe-12345.com').subscribe({
      error: (err) => {
        throw err;
      },
    });
  }
}

